import { combineReducers } from 'redux';

import data from './data';
import hardware from './hardware';
import ui from './ui';

export default combineReducers({
  data,
  ui,
  hardware,
});
